var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWftm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1969FF;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fantom circle@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fantom-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 512,
    cy: 512,
    r: 512
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M481,162.8c17.2-9.1,43.5-9.1,60.7,0l176,92.8c10.4,5.5,16.1,13.6,17.1,22.1h0.2v466.4 c-0.2,9.2-6,18.3-17.3,24.3l-176,92.8c-17.2,9.1-43.5,9.1-60.7,0l-176-92.8c-11.2-5.9-16.6-15.1-16.9-24.3c0-0.9,0-1.7,0-2.3 l0-460.9c0-0.6,0-1.3,0-1.9l0-1.2h0.1c0.8-8.5,6.2-16.5,16.8-22.1L481,162.8z M707,537l-165.4,87.5c-17.2,9.1-43.4,9.1-60.7,0 l-165-87.3v205.5l165,86.8c9.8,5.2,19.9,10.3,29.8,10.5l0.6,0c9.9,0,19.4-5,29.1-9.7L707,741.9V537z M260.4,734 c0,17.9,2.1,29.6,6.1,37.9c3.4,6.9,8.5,12.1,17.8,18.5l0.5,0.4c2,1.4,4.3,2.8,7,4.5l3.2,2l9.9,6L290.8,827l-11.1-6.7l-1.9-1.2 c-3.2-2-5.9-3.7-8.3-5.4c-26.5-18-36.3-37.6-36.5-78.5l0-1.2H260.4z M498,413c-1.3,0.4-2.5,1-3.6,1.5l-175.7,93.1 c-0.2,0.1-0.4,0.2-0.5,0.3L318,508l0.3,0.2l0.4,0.2l175.7,93.1c1.1,0.6,2.3,1.1,3.6,1.5V413z M526,413v190c1.3-0.4,2.5-1,3.6-1.5 l175.7-93.1c0.2-0.1,0.4-0.2,0.5-0.3l0.1-0.1l-0.3-0.2l-0.4-0.2l-175.7-93.1C528.5,414,527.3,413.4,526,413z M707,311l-158,83 l158,83V311z M316,311v166l158-83L316,311z M529.4,187.6c-9.1-4.8-25.7-4.8-34.8,0l-175.9,93c-0.2,0.1-0.4,0.2-0.5,0.3L318,281 l0.3,0.2l0.4,0.2l175.9,93c9.1,4.8,25.7,4.8,34.8,0l175.9-93c0.2-0.1,0.4-0.2,0.5-0.3l0.1-0.1l-0.3-0.2l-0.4-0.2L529.4,187.6z  M733.2,197l11.1,6.7l1.9,1.2c3.2,2,5.9,3.7,8.3,5.4c26.5,18,36.3,37.6,36.5,78.5l0,1.2h-27.4c0-17.9-2.1-29.6-6.1-37.9 c-3.4-6.9-8.5-12.1-17.8-18.5l-0.5-0.4c-2-1.4-4.3-2.8-7-4.5l-3.2-2l-9.9-6L733.2,197z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWftm);
export default __webpack_public_path__ + "static/media/wftm.ba55618939d538f2559e2ec6e96190db.svg";
export { ForwardRef as ReactComponent };